/* eslint-disable no-param-reassign */
// import store from 'store'
import axios from 'axios';
import showNotification from 'commons/helpers/showNotification';
import { getCurrentUser, resetStore } from 'stores/appStore';

// MAIN HTTP CODES
const UNAUTHORIZED_ACCESS = 401;
const FORBIDDEN = 403;
// CORE SETUP
let baseUrl = 'http://localhost:8090';
if (process.env.REACT_APP_STAGE === 'staged') {
  baseUrl = 'https://stagedapi.minhaagendaapp.com.br';
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://api.minhaagendaapp.com.br';
}

const AXIOS_PARAMS =
  process.env.NODE_ENV === 'production'
    ? {
        baseURL: baseUrl,
        withCredentials: true,
        timeout: 20 * 1000,
      }
    : {
        baseURL: baseUrl,
        withCredentials: true,
      };

// if (process.env.REACT_APP_ENV === 'prod') {
// baseUrl = 'http://ec2-52-67-130-195.sa-east-1.compute.amazonaws.com:8088';
// }
// test base url

const httpService = axios.create(AXIOS_PARAMS);

httpService.interceptors.request.use(
  (config) => {
    // store.dispatch({ type: 'REQUEST_LOADING', data: { isLoading: true } })
    // globalRequestState.store.setState({ isLoading: true });
    // SET TOKEN HERE
    // config.headers.Authorization = `Bearer ${access_token}`;
    // setGlobal({ requestLoading: true });
    if (!config.url.startsWith('/oauth/token')) {
      const theCurrentUser = getCurrentUser();
      if (theCurrentUser && theCurrentUser.access_token) {
        config.headers.Authorization = `Bearer ${theCurrentUser.access_token}`;
      }
    }
    // Do something before request is sent)
    return config;
  },
  (error) => {
    // Do something with request error
    // eslint-disable-next-line no-console
    console.log('request error');
    // eslint-disable-next-line no-console
    console.error(error);

    // store.dispatch({ type: 'REQUEST_LOADING', data: { isLoading: false } })
    // globalRequestState.store.setState({ isLoading: false });
    // setGlobal({ requestLoading: false });

    return Promise.reject(error);
  },
);

httpService.interceptors.response.use(
  (response) => {
    // console.log('intercept response')
    // globalRequestState.store.setState({ isLoading: false });
    // setGlobal({ requestLoading: false });

    // store.dispatch({ type: 'REQUEST_LOADING', data: { isLoading: false } })
    // if (response.data.error === true) {
    //     const message = response.data.element.errormessage || 'Server Error! Please verify'
    //     store.dispatch({ type: 'SHOW_SNACKBAR', data: { type: 'error', message } })
    // }
    return response.data;
  },
  (error) => {
    // eslint-disable-next-line no-console
    // console.log('response error');
    // eslint-disable-next-line no-console
    // console.log(error);
    // store.dispatch({ type: 'REQUEST_LOADING', data: { isLoading: false } })
    // globalRequestState.store.setState({ isLoading: false });
    // setGlobal({ requestLoading: false });

    if (error.response) {
      const { response } = error;
      if (response.status === UNAUTHORIZED_ACCESS || response.status === FORBIDDEN) {
        const message = response.data.message || 'Acesso não autorizado.';
        showNotification('error', message);
        resetStore();
        // store.dispatch({ type: 'SHOW_SNACKBAR', data: { type: 'warning', message } })
        // store.dispatch({ type: 'LOGOUT' })
      } else if (response.status >= 400 && response.status < 499) {
        const body = response.data || {};
        // 'Incorrect usage!'
        let message = body.message || 'Uso incorreto!';
        if (response.status === 400 && body.error && body.error === 'invalid_grant') {
          message = body.error_description;
        }
        // error messages
        if (body.errors && body.errors.length > 0) {
          message = '';
          body.errors.forEach((el) => {
            const field = el.field ? `${el.field}: ` : '';
            message += `${field}${el.defaultMessage ?? ''}`;
          });
        }
        if (message === 'Old password does not match') {
          message = 'A senha antiga não confere.';
        }
        // globalMessageQueue.store.setState({ type: 'warning', message: message });
        showNotification('warning', message);
      } else if (response.status >= 500 && response.status < 599) {
        // store.dispatch({ type: 'SHOW_SNACKBAR', data: { type: 'error', message: 'Server Error. Please contact the support team.' } })
        // Server side error. Please contact our support team.
        // globalMessageQueue.store.setState({ type: 'error', message: 'Server Error. Please contact the support team.' });
        showNotification('error', 'Erro. Por favor contate a equipe de suporte.');
      }
      // eslint-disable-next-line no-console
      console.error(response);
    } else if (error) {
      // store.dispatch({ type: 'SHOW_SNACKBAR', data: { type: 'error', message: 'Server unavailable.' } })
      // globalMessageQueue.store.setState({ type: 'error', message: 'Server unavailable.' });

      if (error && error.toJSON().message === 'Network Error') {
        showNotification('error', 'Problema com sua conexão com a internet.');
        // dispatch({type: RELOAD});
      } else {
        showNotification('error', 'Problema de conexão. Contate o suporte em caso de dúvidas.');
      }
      // 'Could not reach the server.'
    }
    return Promise.reject(error);
  },
);

export default httpService;
